import { render, staticRenderFns } from "./baseCom.vue?vue&type=template&id=5e164a5f&scoped=true"
import script from "./baseCom.vue?vue&type=script&lang=js"
export * from "./baseCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=5e164a5f&prod&scoped=true&lang=css&external"
import style1 from "./baseCom.vue?vue&type=style&index=1&id=5e164a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e164a5f",
  null
  
)

export default component.exports